import {UI, type PartialOptions} from "../../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../../stem-core/ui/Style";
import {styleRule} from "../../../../stem-core/decorators/Style";
import {registerStyle} from "../../../../stem-core/ui/style/Theme";
import {CheckmarkIcon} from "../../SVGElements.jsx";


export class DropdownItemStyle extends StyleSheet {
    @styleRule
    container = {
        cursor: "pointer",
        transition: this.themeProps.DEFAULT_TRANSITION,
        ":hover": {
            background: this.themeProps.INPUT_BACKGROUND_HOVER,
        },
        display: "flex",
        flexDirection: "row",
        ">:first-child": {
            flex: 1,
        },
        ">:nth-child(2)": {
            width: 40,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        ">:nth-child(2)>*": {
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
        },
    };
}

interface DropdownItemOptions {
    // Structural rather than importing DropdownList, which imports this module.
    list: {dispatch(event: string, item: unknown): void};
    item: unknown;
}

@registerStyle(DropdownItemStyle)
export class DropdownItem extends UI.Element<DropdownItemOptions> {
    getDefaultOptions(): PartialOptions<DropdownItem> {
        return {
            ...super.getDefaultOptions(),
            active: false,
            list: null,
            item: null,
        };
    }

    render() {
        return [
            <div>{super.render()}</div>,
            <div>
                <div>{this.options.active ? <CheckmarkIcon size={14} testId="dropdownItemMark" /> : null}</div>
            </div>,
        ];
    }

    setActive() {
        this.options.list.dispatch("changeActive", this.options.item);
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => this.setActive());
    }
}
